import { Slider, SliderItem } from './slider';

export default {
	name: 'BlogNewsletter',
	components: {
		Slider,
		SliderItem,
	},
	data() {
		return {
			next: 0,
			slider: null,
		}
	},
	mounted() {
		this.$refs.slider.$on('page-change', (page) => { this.moveImge(page) });

		this.autoSlider();
	},
	methods: {
		moveImge(page) {
			this.$refs
				.preview
				.querySelector('#blog-imgs')
				.style.transform = `translateX(-${page * 100}%)`
		},

		nextPost() {
			let current = this.$refs.slider.currPage;
			let numPages = this.$refs.slider.numPages;

			this.next = current + 1;
			if (this.next > numPages) {
				this.next = 1
			}

			this.$refs.slider.currPage = this.next;
			this.moveImge(this.next);
		},

		autoSlider() {
			return setInterval(() => {
				if (this.$refs.preview.querySelector(':hover') === null) {
					this.nextPost();
				}
			}, 5000);
		},

		submitForm() {
			setTimeout(() => {
				this.$refs.email_newsletter.value = "";
			}, 500);
		},
	},
}
